module.exports = __webpack_public_path__ + "d1e38f723af102c656fd9c11472a0ed7.svg";